import React from 'react'
import { DesignedModal, Button, StyledText } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { useIsTrialSubscription } from 'Hooks/trial/useIsTrialSubscription'

export const VerifyProductCancellationModal = ({
  isOpen,
  setIsOpen,
  onConfirm,
  onCancel,
  productName,
  loading,
}: {
  isOpen: boolean
  setIsOpen: (val: boolean) => void
  onConfirm: () => void
  onCancel: () => void
  productName?: string
  loading?: boolean
}) => {
  const { t } = useTranslation('accountSettings')
  const isTrialSubscription = useIsTrialSubscription()

  const translate = (key: string) =>
    t(`plan_details.verify_product_cancellation_modal.${key}`, { product: productName })

  const accountTrial = isTrialSubscription ? '_account_trial' : ''

  return (
    <DesignedModal
      isOpen={isOpen}
      title={translate('title')}
      onOpenChange={setIsOpen}
      actions={
        <>
          <Button variant="ghost" onClick={onCancel} text={translate('secondary_button')} />
          <Button
            onClick={onConfirm}
            text={translate(`primary_button${accountTrial}`)}
            loading={loading}
          />
        </>
      }
    >
      <StyledText>{translate(`body${accountTrial}`)}</StyledText>
    </DesignedModal>
  )
}
